// Champs d'édition partagés (CC-DEV1-18, extraits d'InfosTab sans changement de rendu) —
// N°1002 #8 : réutilisés par l'étape « Informations client » du devis en modification.
import React from "react";

// Primitives d'édition (mêmes styles que le bloc Compte ANAH déjà en place).
export function EditText({ label, value, onChange, type = "text", testId }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wide mb-1" style={{ color: "var(--oh-text-muted)" }}>{label}</div>
      <input type={type} value={value || ""} onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md px-2 py-1.5 text-sm" style={{ background: "var(--oh-bg-surface)", border: "1px solid var(--oh-border)", color: "var(--oh-text)" }} data-testid={testId} />
    </div>
  );
}
export function EditSelect({ label, value, onChange, options, testId }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wide mb-1" style={{ color: "var(--oh-text-muted)" }}>{label}</div>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md px-2 py-1.5 text-sm" style={{ background: "var(--oh-bg-surface)", border: "1px solid var(--oh-border)", color: "var(--oh-text)" }} data-testid={testId}>
        <option value="">—</option>
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}
